<template>
  <v-layout row wrap>
    <!-- Dialog -->
    <v-dialog
      v-model="json_data.status"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay="false"
    >
      <v-card style="background-color: #eeeeee">
        <v-toolbar dark color="primary">
          <v-tooltip bottom>
            <v-btn slot="activator" icon dark @click="closeDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <span>{{ $t("close") }}</span>
          </v-tooltip>
          <v-toolbar-title
            ><span>{{
              json_data.save_type == "create"
                ? $t("menu.GroupPermissionsCreate")
                : $t("menu.GroupPermissionsCreate")
            }}</span></v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn
            flat
            dark
            @click="json_data.save_type == 'create' ? onSave() : onUpdate()"
          >
            <v-icon>save</v-icon>
            <span class="px-2">{{
              json_data.save_type == "create" ? $t("create") : $t("save")
            }}</span>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container background fluid pa-4>
            <v-layout
              row
              wrap
              pa-4
              ma-4
              style="
                background-color: #fff;
                margin-top: 5px;
                border-radius: 5px;
              "
            >
              <v-flex xs12>
                <v-form ref="form" v-model="form_valid">
                  <v-layout row wrap>
                    <v-flex
                      md4
                      sm4
                      xs12
                      pa-1
                      v-if="json_data.save_type != 'create'"
                    >
                      <v-text-field
                        :label="$t('group_number')"
                        hide-details
                        v-model="permissions.group_code"
                        :rules="form_rules.group_code"
                        required
                        readonly
                      />
                    </v-flex>
                    <v-flex
                      md4
                      sm4
                      xs12
                      pa-1
                      v-if="json_data.save_type == 'create'"
                    >
                      <v-text-field
                        :label="$t('group_number')"
                        append-icon="fas fa-plus-circle"
                        hide-details
                        v-model="permissions.group_code"
                        :rules="form_rules.group_code"
                        required
                        @click:append="doNewGuid"
                      />
                    </v-flex>
                    <v-flex md4 sm4 xs12 pa-1>
                      <v-text-field
                        :label="$t('groupname')"
                        hide-details
                        v-model="permissions.group_name"
                        :rules="form_rules.group_name"
                        required
                      />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
              <v-flex xs12>
                <v-layout md6 sm6 xs12 pa-1 ma-5>
                  <v-flex
                    xs12
                    md12
                    sm12
                    style="max-height: 70vh; border-radius: 5px; box-shadow: 2px 2px 4px #CFD8DC;"
                    class="scroll-able text-center"
                  >
                    <table
                      id="table_detail"
                      class="table table-borderless sticky-table"
                      style="height: 300px !important; overflow: auto ;"
                    >
                      <thead>
                        <tr style="color: #fff">
                          <th nowrap style="width: 70%"><span>{{$t('menu_list')}}</span></th>
                          <th nowrap style="width: 10%">
                            <span>{{$t('all')}}</span>
                          </th>
                          <th nowrap style="width: 10%"><span>{{$t('edit')}}</span></th>
                          <th nowrap style="width: 10%"><span> {{$t('view')}}</span></th>
                        </tr>
                      </thead>
                      <tbody
                        v-for="(item, index) in topic"
                        :key="index"
                        @click="
                          '';

                        "
                        style="vertical-align: middle"
                      >
                        <tr>
                          <td
                            nowrap
                            colspan="4"
                            style="background-color: #4DB6AC"
                          >
                            <p
                              style="
                                font-size: 1rem;
                                margin-top: 10px;
                                color: #fff;
                              "
                            >
                              <strong>{{ $t("menu." + index) }}</strong>
                            </p>
                          </td>
                        </tr>
                        <tr v-for="(sub, i) in item" :key="i">
                          <td nowrap>
                            <p style="margin-top: 15px">
                              - - &nbsp;{{ $t("menu." + sub.module_name) }}
                            </p>
                          </td>
                          <td nowrap>
                            <v-checkbox
                              v-model="sub.full_control"
                              class="mx-2"
                              color="info"
                              @change="selectAll(sub)"
                            ></v-checkbox>
                          </td>
                          <td nowrap>
                            <v-checkbox
                              v-model="sub.edit"
                              class="mx-2"
                              color="success"
                              @change="selectSome(sub)"
                            ></v-checkbox>
                          </td>
                          <td nowrap>
                            <v-checkbox
                              v-model="sub.reads"
                              class="mx-2"
                              color="success"
                              @change="selectSome(sub)"
                            ></v-checkbox>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12 text-xs-right pa-3>
              <v-btn
                color="success"
                @click="json_data.save_type == 'create' ? onSave() : onUpdate()"
              >
                <v-icon>save</v-icon>
                <span class="px-2">{{
                  json_data.save_type == "create" ? $t("create") : $t("save")
                }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <v-snackbar
      v-model="snack_model.status"
      :timeout="3500"
      :top="'top'"
      :color="snack_model.type"
    >
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import Utils from "@/utils/";
import DocumentService from "@/services/DocumentService";
import { async } from "q";
import EmployeeService from "@/services/EmployeeService";
export default {
  props: {
    json_data: Object,
  },
  watch: {
    async json_data(val) {
      console.log(val);
      this.getEmployee("newData");
      if (val.data != null) {
        this.form_model = val.data;
        console.log(this.form_model);
        await this.getDataGroup();
      } else {
        this.doNewGuid();
        await this.getDataGroup();
        //this.$refs.form.resetValidation();
      }
    },
  },
  data: () => ({
    form_valid: false,
    group: [],
    permissions: {
      group_code: "",
      group_name: "",
      editor_code: localStorage._usercode,

      permission: [],
    },
    group_Permission: {
      group_name: "",
      group_code: "",
      editor_code: localStorage._usercode,

      permission: [],
    },
    //selectAll: false,
    modulelist: [
      {
        group: "EmployeeList",
        module_name: "EmployeeList",
        edit: false,
        reads: false,
      },
      {
        group: "Employeeinactive",
        module_name: "Employeeinactive",
        edit: false,
        reads: false,
      },
      {
        group: "ImportFile",
        module_name: "ImportFileIncome",
        edit: false,
        reads: false,
      },
      {
        group: "ImportFile",
        module_name: "ImportFileExpensed",
        edit: false,
        reads: false,
      },
      {
        group: "ImportFile",
        module_name: "ImportFingerScan",
        edit: false,
        reads: false,
      },
      {
        group: "เพิ่มเอกสารร้องขอ",
        module_name: "ExpensedList",
        edit: false,
        reads: false,
      },
      {
        group: "เพิ่มเอกสารร้องขอ",
        module_name: "IncomeList",
        edit: false,
        reads: false,
      },
      {
        group: "เพิ่มเอกสารร้องขอ",
        module_name: "CheckInOutList",
        edit: false,
        reads: false,
      },
      {
        group: "เพิ่มเอกสารร้องขอ",
        module_name: "TakeLeaveList",
        edit: false,
        reads: false,
      },
      {
        group: "เพิ่มเอกสารร้องขอ",
        module_name: "ChangePlanList",
        edit: false,
        reads: false,
      },
      {
        group: "เพิ่มเอกสารร้องขอ",
        module_name: "OTPlanList",
        edit: false,
        reads: false,
      },
      {
        group: "เพิ่มเอกสารร้องขอ",
        module_name: "ReSignList",
        edit: false,
        reads: false,
      },
      {
        group: "เพิ่มเอกสารร้องขอ",
        module_name: "ChangeSalaryList",
        edit: false,
        reads: false,
      },
      {
        group: "เพิ่มเอกสารร้องขอ",
        module_name: "CommissionList",
        edit: false,
        reads: false,
      },
      {
        group: "แผนงานและเวลาทำงาน",
        module_name: "ChangeWorkplanList",
        edit: false,
        reads: false,
      },
      {
        group: "แผนงานและเวลาทำงาน",
        module_name: "CheckInList",
        edit: false,
        reads: false,
      },
      {
        group: "แผนงานและเวลาทำงาน",
        module_name: "TimeCheckList",
        edit: false,
        reads: false,
      },
      {
        group: "แผนงานและเวลาทำงาน",
        module_name: "WorkPlanByEMPList",
        edit: false,
        reads: false,
      },
      {
        group: "เงินเดือนและการจ่ายเงิน",
        module_name: "SalaryTableList",
        edit: false,
        reads: false,
      },
      {
        group: "เงินเดือนและการจ่ายเงิน",
        module_name: "PayRollDocumentList",
        edit: false,
        reads: false,
      },
      {
        group: "ตั้งค่าทั่วไป",
        module_name: "HolidayList",
        edit: false,
        reads: false,
      },
      // {
      //   group: "ตั้งค่าทั่วไป",
      //   module_name: "HolidayInYear",
      //   full_control: false,
      //   edit: false,
      //   reads: false
      // },
      {
        group: "ตั้งค่าทั่วไป",
        module_name: "BranchList",
        edit: false,
        reads: false,
      },
      {
        group: "ตั้งค่าทั่วไป",
        module_name: "DepartmentList",
        edit: false,
        reads: false,
      },
      {
        group: "ตั้งค่าทั่วไป",
        module_name: "WorkPlanList",
        edit: false,
        reads: false,
      },
      {
        group: "ตั้งค่าทั่วไป",
        module_name: "ConditionsList",
        edit: false,
        reads: false,
      },
      {
        group: "ตั้งค่าทั่วไป",
        module_name: "CompanyAddress",
        edit: false,
        reads: false,
      },
      {
        group: "ตั้งค่าทั่วไป",
        module_name: "GeneralSetting",
        edit: false,
        reads: false,
      },
      {
        group: "ตั้งค่าทั่วไป",
        module_name: "TaxSettingList",
        edit: false,
        reads: false,
      },
      {
        group: "ตั้งค่าทั่วไป",
        module_name: "DeviceSettingList",
        edit: false,
        reads: false,
      },
      {
        group: "ตั้งค่าทั่วไป",
        module_name: "MappingDeviceSettingList",
        edit: false,
        reads: false,
      },
      {
        group: "ImportFile_Master",
        module_name: "ImportEmployee",
        edit: false,
        reads: false,
      },
      {
        group: "ImportFile_Master",
        module_name: "ImportDepartment",
        edit: false,
        reads: false,
      },
      {
        group: "ImportFile_Master",
        module_name: "ImportBranch",
        edit: false,
        reads: false,
      },
      {
        group: "ImportFile_Master",
        module_name: "ImportHoliday",
        edit: false,
        reads: false,
      },
      {
        group: "Permissions",
        module_name: "IndividualPermissionsList",
        edit: false,
        reads: false,
      },
      {
        group: "Permissions",
        module_name: "GroupPermissionsList",
        edit: false,
        reads: false,
      },
    ],
    form_model: {},
    form_rules: {
      group_code: [(v) => !!v || "do not empty."],
      group_name: [(v) => !!v || "do not empty."],
    },
    snack_model: {
      status: "",
      msg: "",
      type: "",
    },
    detail_module: [],
    topic: [],
  }),
  created: function () {
    this.getEmployee("refesh");
    //this.doNewGuid();
  },
  computed: {
    ...mapState("filter", ["loading", "Employee_List"]),
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    closeDialog() {
      this.$emit("close-dialog");
      this.clearForm();
    },
    doNewGuid() {
      this.permissions.group_code = Utils.newGuid("G");
    },
    // checkgroup(){
    //   this.group =[];
    //   var groupname="";
    //     for (let index = 0; index < this.modulelist.length; index++) {
    //         if(this.modulelist[index].group != groupname){
    //           groupname = this.modulelist[index].group;
    //             //console.log(groupname);
    //             this.group.push({group_name:groupname})
    //         }
    //         else{
    //            groupname = groupname;
    //         }
    //     }
    //     //console.log(this.group)
    //     // var select =false;
    //     // this.modulelist.forEach(element => {
    //     //   if(element.edit == true && element.reads == true){
    //     //       select = true;
    //     //    }
    //     //    else{
    //     //      select = false;
    //     //    }
    //     //   this.permissions.permission.push({
    //     //         group : element.group,
    //     //         module_name: element.module_name,
    //     //         selectAll: select,
    //     //         edit : element.edit,
    //     //         reads : element.reads
    //     //   })
    //     // });
    //     //console.log(this.permissions)
    // },
    comparer(array) {
      return (current_Arr) => {
        return (
          array.filter((arr) => {
            return arr.module_name == current_Arr.module_name;
          }).length == 0
        );
      };
    },
    duplicateArray(arr) {
      const return_arr = [];
      let role;
      this.modulelist.forEach((el1) => {
        role = arr.filter((array) => {
          return array.module_name == el1.module_name;
        });
        console.log(role[0]);
        if (role.length > 0) {
          return_arr.push(role[0]);
        }
      });

      return return_arr;
    },
    checktimeatt(arr) {
      var checktiime_arr = [];
      var time = localStorage._is_timeattendance;
      if (time == 0) {
        arr.forEach((item) => {
          if (
            item.group != "แผนงานและเวลาทำงาน" &&
            item.module_name != "ImportFingerScan" &&
            item.module_name != "CheckInOutList" &&
            item.module_name != "TakeLeaveList" &&
            item.module_name != "ChangePlanList" &&
            item.module_name != "OTPlanList" &&
            item.module_name != "WorkPlanList" &&
            item.module_name != "ConditionsList" &&
            item.module_name != "DeviceSettingList" &&
            item.module_name != "MappingDeviceSettingList"
          ) {
            checktiime_arr.push(item);
          }
        });
      } else {
        checktiime_arr = arr;
      }
      return checktiime_arr;
    },
    checkfullcontrol(arr) {
      var checkfull = [];
      arr.forEach((element) => {
        if (element.reads == true && element.edit == true) {
          checkfull.push({
            group: element.group,
            reads: element.reads,
            edit: element.edit,
            full_control: true,
            module_name: element.module_name,
          });
        } else {
          checkfull.push({
            group: element.group,
            reads: element.reads,
            edit: element.edit,
            full_control: false,
            module_name: element.module_name,
          });
        }
      });

      return checkfull;
    },
    selectAll(item) {
      // console.log("selectall : " + item.full_control);
      if (item.full_control) {
        item.reads = true;
        item.edit = true;
      } else {
        item.reads = false;
        item.edit = false;
      }
    },
    selectSome(item) {
      if (item.edit && item.reads) {
        item.full_control = true;
      } else {
        item.full_control = false;
      }
    },
    getDataGroup() {
      console.log(this.form_model);
      EmployeeService.getPermissionbyGroup(this.form_model.group_code)
        .then((res) => {
          console.log(res.data);
          if (res.data != null) {
            var arr1 = this.modulelist.filter(
              this.comparer(res.data.permission)
            );
            var arr2 = this.duplicateArray(res.data.permission);
            this.detail_module = this.checktimeatt(
              this.checkfullcontrol(arr2.concat(arr1))
            );
            console.log(this.detail_module);
            this.topic = this.groupBy(this.detail_module, "group");
            this.permissions.group_code = res.data.group_code;
            this.permissions.group_name = res.data.group_name;
            this.permissions.editor_code = res.data.editor_code;

            console.log(this.permissions);
          } else {
            this.detail_module = this.checktimeatt(
              this.checkfullcontrol(this.modulelist)
            );
            this.topic = this.groupBy(this.detail_module, "group");
            console.log(this.permissions);
          }
        })
        .catch((err) => {
          this.detail_module = this.checktimeatt(
            this.checkfullcontrol(this.modulelist)
          );
          this.topic = this.groupBy(this.detail_module, "group");
        });
    },
    groupBy(arr, key) {
      const result = {};
      arr.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    clearForm() {
      this.topic = [];
      (this.permissions = {
        group_code: "",
        editor_code: localStorage._usercode,
        permission: [],
      }),
        (this.group_Permission = {
          group_name: "",
          group_code: "",
          editor_code: localStorage._usercode,

          permission: [],
        });
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    // getDetail(param) {
    //   DocumentService.getResignByCode(param)
    //     .then(res => {
    //       this.showLoading = false;
    //       this.form_model = res.data;
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     });
    // },
    onSave() {
      if (this.form_valid) {
        let arr = [];
        this.group_Permission.group_code = this.permissions.group_code;
        this.group_Permission.group_name = this.permissions.group_name;
        this.group_Permission.editor_code = this.permissions.editor_code;

        this.detail_module.forEach((element) => {
          this.group_Permission.permission.push({
            group: element.group,
            module_name: element.module_name,
            edit: element.edit,
            reads: element.reads,
          });
          //console.log(this.group_Permission);
        });
        EmployeeService.CreateGroupPermission(this.group_Permission)
          .then((res) => {
            this.showSnackBar("save success", "success");
            this.closeDialog();
          })
          .catch((err) => {
            this.showSnackBar(err.message, "error");
          });
      } else {
        this.$refs.form.validate();
      }
    },
    onUpdate() {
      if (this.form_valid) {
        let arr = [];
        this.group_Permission.group_code = this.permissions.group_code;
        this.group_Permission.group_name = this.permissions.group_name;
        this.group_Permission.editor_code = this.permissions.editor_code;

        this.detail_module.forEach((element) => {
          this.group_Permission.permission.push({
            group: element.group,
            module_name: element.module_name,
            edit: element.edit,
            reads: element.reads,
          });
          //console.log(this.group_Permission);
        });
        EmployeeService.CreateGroupPermission(this.group_Permission)
          .then((res) => {
            this.showSnackBar("update success", "success");
            this.closeDialog();
          })
          .catch((err) => {
            this.showSnackBar(err.message, "error");
          });
      } else {
        this.$refs.form.validate();
      }
      // if (this.form_valid) {
      //   DocumentService.updateResing(this.form_model)
      //     .then(res => {
      //       this.showSnackBar('update success', 'success');
      //       this.closeDialog();
      //     })
      //     .catch(err => {
      //       this.showSnackBar(err.response.data, 'error');
      //     });
      // } else {
      //   this.$refs.form.validate();
      // }
    },
  },
};
</script>
<style>
.v-card__text {
  padding: 0px !important ;
}
.sticky-table th {
  background-color: #009688;
  position: sticky;
  top: 0;
  z-index: 1;
}
th {
  text-align: left;
}
</style>
